// assets
import { ContactsOutlined, EyeOutlined, EditOutlined } from "@ant-design/icons";

// icons
const icons = {
  ContactsOutlined,
  EyeOutlined,
  EditOutlined,
};

// ==============================|| MENU ITEMS - SAMPLE PAGE & DOCUMENTATION ||============================== //

const guests = {
  id: "guests-group",
  title: "Guests",
  type: "group",
  children: [
    {
      id: "guests-collapse",
      title: "Guest List",
      type: "collapse",
      url: "/guests",
      icon: icons.ContactsOutlined,
      children: [
        // hidden items for breadcrumbs only
        {
          id: "edit-guest",
          title: "Edit Guest",
          type: "item",
          url: "/editGuest",
          icon: icons.EditOutlined,
          hidden: true,
        },
        {
          id: "show-guest",
          title: "Guest Data",
          type: "item",
          url: "/showGuest",
          icon: icons.EyeOutlined,
          hidden: true,
        },
      ],
    },
  ],
};

export default guests;
